import React from "react";
import ReactECharts from "echarts-for-react";

const PieChartComponent: React.FC = () => {
  const options = {
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b}: {c} ({d}%)",
    },
    legend: {
      orient: "horizontal",
      bottom: "0",
      data: ["Completed", "Canceled", "Pending"],
    },
    series: [
      {
        name: "Contracts Rate",
        type: "pie",
        radius: ["50%", "70%"], // Donut chart
        avoidLabelOverlap: false,
        label: {
          show: true,
          formatter: "{b}\n{d}%",
        },
        labelLine: {
          show: true,
        },
        data: [
          { value: 50, name: "Completed", itemStyle: { color: "#34d399" } },
          { value: 22, name: "Canceled", itemStyle: { color: "#f87171" } },
          { value: 28, name: "Pending", itemStyle: { color: "#facc15" } },
        ],
      },
    ],
  };

  return (
    <div className="bg-white p-6 rounded-3xl w-full">
      <h3 className="text-base font-semibold text-gray-700 mb-4">Contracts Rate</h3>
      <ReactECharts option={options} style={{ height: 300, width: "100%" }} />
    </div>
  );
};

export default PieChartComponent;
